"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function compareStrings(sA, sB) {
    return sA > sB ? 1 : sA < sB ? -1 : 0;
}
exports.compareStrings = compareStrings;
function compareNumbers(sA, sB) {
    return sA - sB;
}
exports.compareNumbers = compareNumbers;
function reverse(r) {
    return -r;
}
exports.reverse = reverse;
function compareStringsCaseInsensitive(sA, sB) {
    return sA.localeCompare(sB, undefined, {
        sensitivity: 'base',
    });
}
exports.compareStringsCaseInsensitive = compareStringsCaseInsensitive;
function sortFunction(gen) {
    return (a, b) => {
        for (let comp of gen(a, b)) {
            if (comp) {
                return comp;
            }
        }
        return 0;
    };
}
exports.sortFunction = sortFunction;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUdBLFNBQWdCLGNBQWMsQ0FBQyxFQUFVLEVBQUUsRUFBVTtJQUNqRCxPQUFPLEVBQUUsR0FBRyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRSxHQUFHLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQTtBQUN6QyxDQUFDO0FBRkQsd0NBRUM7QUFFRCxTQUFnQixjQUFjLENBQUMsRUFBVSxFQUFFLEVBQVU7SUFDakQsT0FBTyxFQUFFLEdBQUcsRUFBRSxDQUFBO0FBQ2xCLENBQUM7QUFGRCx3Q0FFQztBQUVELFNBQWdCLE9BQU8sQ0FBQyxDQUFnQjtJQUNwQyxPQUFPLENBQUMsQ0FBQyxDQUFBO0FBQ2IsQ0FBQztBQUZELDBCQUVDO0FBRUQsU0FBZ0IsNkJBQTZCLENBQUMsRUFBVSxFQUFFLEVBQVU7SUFDaEUsT0FBTyxFQUFFLENBQUMsYUFBYSxDQUFDLEVBQUUsRUFBRSxTQUFTLEVBQUU7UUFDbkMsV0FBVyxFQUFFLE1BQU07S0FDdEIsQ0FBa0IsQ0FBQTtBQUN2QixDQUFDO0FBSkQsc0VBSUM7QUFFRCxTQUFnQixZQUFZLENBQ3hCLEdBQW9EO0lBRXBELE9BQU8sQ0FBQyxDQUFJLEVBQUUsQ0FBSSxFQUFFLEVBQUU7UUFDbEIsS0FBSyxJQUFJLElBQUksSUFBSSxHQUFHLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxFQUFFO1lBQ3hCLElBQUksSUFBSSxFQUFFO2dCQUNOLE9BQU8sSUFBSSxDQUFBO2FBQ2Q7U0FDSjtRQUVELE9BQU8sQ0FBQyxDQUFBO0lBQ1osQ0FBQyxDQUFBO0FBQ0wsQ0FBQztBQVpELG9DQVlDIn0=